import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const cloudSbpPromo = isFeature('cloud-spb-promo');
